import { mutationNames } from '@/store/storeKey'
import api from '@/modules/api'
import * as storage from '@/modules/storage'

const masterDemoApp = {
  WebApp_AppModifiedSinceLastPublishing: false,
  WebApp_PublishingPending: false,
  IsActive: false,
  AppDescription: '',
  GooglePlay_Published: false,
  GooglePlay_PublishingPending: false,
  Active: false,
  AppName: '',
  AppThumbnailImageGenerated: false,
  GooglePlay_AppModifiedSinceLastPublishing: false,
  AppLanguage: 'EN',
  AppleAppStore_Published: false,
  Id: 0,
  Client_Id: 0,
  AppleAppStore_PublishingPending: false,
  AppleAppStore_AppModifiedSinceLastPublishing: false,
  PurchasedSubscriptionLevel_Id: 1,
  StartDate: '2016-11-23T13:25:29.893',
  SubscriptionActive: false,
  SubscriptionLevel_Id: 1,
  SubscriptionName: 'FREE APP',
  Subscription_GUID: '00000000-0000-0000-0000-000000000000',
  VersionMajorNumber: 1,
  VersionMinorNumber: 0,
  WebApp_Published: false
}

const state = {
  subscriptions: [],
  activeSubscriptionId: storage.subscriptionId.get(),
  subscriptionProducts: [],
  purchasedProduct: [],
  CheckoutVendorSubscriptionId: null,
  subscriptionPurchaseStatus: true
}

const getters = {
  subscriptions: state => state.subscriptions,
  subscriptionsWithDemoApp: state => [...state.subscriptions, masterDemoApp],
  activeSubscriptionId: state => state.activeSubscriptionId,
  subscription: state => state.subscriptions.find(subscription => subscription.Id === state.activeSubscriptionId),
  subscriptionProducts: state => state.subscriptionProducts,
  purchasedProduct: state => state.purchasedProduct,
  CheckoutVendorSubscriptionId: state => state.CheckoutVendorSubscriptionId,
  subscriptionPurchaseStatus: state => state.subscriptionPurchaseStatus
}

const mutations = {
  [mutationNames.SET_SUBSCRIPTIONS] (state, subscriptions) {
    state.subscriptions = subscriptions
  },

  [mutationNames.SET_ACTIVE_SUBSCRIPTION_ID] (state, subscriptionId) {
    state.activeSubscriptionId = subscriptionId
  },
  setSubscriptionLevelId (state, payload) {
    let subscription = state.subscriptions.find(a => a.Id === payload.subscriptionId)
    subscription.SubscriptionLevel_Id = payload.levelId
  },
  setPurchasedSubscriptionLevelId (state, subsciprionId, purchasedSubscriptionLevelId) {
    state.activeSubscriptionId = purchasedSubscriptionLevelId
  },
  setSubscriptionProducts (state, payload) {
    state.subscriptionProducts = payload
  },
  setPurchasedProduct (state, payload) {
    state.purchasedProduct = payload
  },
  setCheckoutVendorSubscriptionId (state, payload) {
    state.CheckoutVendorSubscriptionId = payload
  },
  setsubscriptionPurchaseStatus (state, payload) {
    state.subscriptionPurchaseStatus = payload
  }
}
const actions = {
  async populateSubscriptions ({ commit, rootGetters }) {
    let payload = {
      Client_Id: rootGetters.user.Id,
      AppLanguage: rootGetters.user.Language,
      CalledFrom: 1
    }
    let response = await api.user.apps(payload)
    let productResponse = await api.Order.getBillingProducts(rootGetters.user.Id)
    let PurchasedProductResponse = await api.Order.getSubscriptionsPurchasedProductsData(response[0].Id)
    let PurchaseStatus = PurchasedProductResponse.length > 0 ? !PurchasedProductResponse.find(data => !data.SubscriptionsPurchasedStatus) : true
    commit('setsubscriptionPurchaseStatus', PurchaseStatus)
    if (response[0] && !response[0].Invited) {
      commit('setPurchasedProduct', PurchasedProductResponse)
      let VendorSubscriptionId = ''
      PurchasedProductResponse.forEach(data => {
        if (data.CheckoutVendorSubscriptionId) {
          VendorSubscriptionId = data.CheckoutVendorSubscriptionId
        }
      })
      commit('setCheckoutVendorSubscriptionId', VendorSubscriptionId)
    }
    commit(mutationNames.SET_SUBSCRIPTIONS, response)
    commit('setSubscriptionProducts', productResponse)
  },

  setFirstOrAvailableSelectedApp ({ dispatch, getters }) {
    const subscriptions = getters.subscriptions
    if (subscriptions && subscriptions.length > 0) {
      let subscriptionId = subscriptions[0].Id
      if (storage.subscriptionId.get()) {
        const savedId = storage.subscriptionId.get()
        if (subscriptions.find(subscription => subscription.Id === savedId)) {
          subscriptionId = savedId
        }
      }
      dispatch('setActiveSubscriptionId', subscriptionId)
    }
  },

  async setActiveSubscriptionId ({ commit, dispatch, getters }, subscriptionId) {
    if (getters.activeSubscriptionId !== subscriptionId) {
      storage.subscriptionId.set(subscriptionId)
      commit(mutationNames.SET_ACTIVE_SUBSCRIPTION_ID, subscriptionId)
      commit(mutationNames.SET_DESIGN_SETTINGS, {})
      commit(mutationNames.SET_START_PAGE, {})
      commit(mutationNames.SET_SUBSCRIPTIONS_MODULES, [])
      let PurchasedProductResponse = await api.Order.getSubscriptionsPurchasedProductsData(subscriptionId)
      let PurchaseStatus = PurchasedProductResponse.length > 0 ? !PurchasedProductResponse.find(data => !data.SubscriptionsPurchasedStatus) : true
      commit('setsubscriptionPurchaseStatus', PurchaseStatus)
      if (getters.subscription && !getters.subscription.Invited) {
        commit('setPurchasedProduct', PurchasedProductResponse)
        dispatch('updatedLastAccessSubscription', subscriptionId)
      }
      dispatch('populateDashboardAnalytics')
    }
  },

  updatedLastAccessSubscription (ctx, subscriptionId) {
    return api.subscription.updateLastAccess(subscriptionId)
  },

  deleteSubscription ({ dispatch }, payload) {
    return api.subscription.deleteSubscription(payload)
  },
  deleteSubscriptionWithChargebee ({ dispatch }, payload) {
    return api.subscription.deleteSubscriptionWithChargebee(payload)
  },
  async updateSubscriptionLevel ({ commit }, payload) {
    let updatePayload = {
      Id: payload.subscriptionId,
      SubscriptionLevel_Id: payload.levelId,
      PurchasedSubscriptionLevel_Id: 0
    }
    await api.subscription.updateSubscription(updatePayload)
    commit('setSubscriptionLevelId', payload)
  },
  setSubscriptions ({ commit }, payload) {
    commit(mutationNames.SET_SUBSCRIPTIONS, payload)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/subscription.js